import React, { lazy, Suspense } from 'react';
import { Routes, Route } from 'react-router-dom';
import ProtectedRoute from '../components/ProtectedRoute/ProtectedRoute';
import PublicRoute from '../components/PublicRoute/PublicRoute';
import Preloader from '../pages/Preloader/Preloader';

// Lazy loading для улучшения производительности
const Landing = lazy(() => import('../pages/Landing/Landing'));
const Login = lazy(() => import('../pages/Login/Login'));
const Register = lazy(() => import('../pages/Register/Register'));
const Welcome = lazy(() => import('../pages/Welcome/Welcome'));
const Tasks = lazy(() => import('../pages/Tasks/Tasks'));
const Task = lazy(() => import('../pages/Task/Task'));
const Settings = lazy(() => import('../pages/Settings/Settings'));
const Profile = lazy(() => import('../pages/Profile/Profile'));
const Projects = lazy(() => import('../pages/Projects/Projects'));
const Project = lazy(() => import('../pages/Project/Project'));
const Articles = lazy(() => import('../pages/Articles/Articles'));
const Article = lazy(() => import('../pages/Article/Article'));
const Chat = lazy(() => import('../pages/Chat/Chat'));
const NotFound = lazy(() => import('../pages/NotFound/NotFound'));

const AppRoutes: React.FC = () => {
    return (
        <Suspense fallback={<Preloader />}>
            <Routes>
                {/* Landing page */}
                <Route 
                    path="/" 
                    element={
                        <Suspense fallback={<Preloader />}>
                            <Landing />
                        </Suspense>
                    } 
                />

                {/* Public routes */}
                <Route 
                    path="/login" 
                    element={
                        <PublicRoute>
                            <Suspense fallback={<Preloader />}>
                                <Login />
                            </Suspense>
                        </PublicRoute>
                    } 
                />
                <Route 
                    path="/register" 
                    element={
                        <PublicRoute>
                            <Suspense fallback={<Preloader />}>
                                <Register />
                            </Suspense>
                        </PublicRoute>
                    } 
                />

                {/* Welcome page для новых пользователей */}
                <Route 
                    path="/welcome" 
                    element={
                        <ProtectedRoute>
                            <Suspense fallback={<Preloader />}>
                                <Welcome />
                            </Suspense>
                        </ProtectedRoute>
                    } 
                />

                {/* Protected routes */}
                <Route 
                    path="/tasks" 
                    element={
                        <ProtectedRoute guestGateVariant="tasks">
                            <Suspense fallback={<Preloader />}>
                                <Tasks />
                            </Suspense>
                        </ProtectedRoute>
                    } 
                />
                <Route 
                    path="/task/:taskId" 
                    element={
                        <ProtectedRoute guestGateVariant="tasks">
                            <Suspense fallback={<Preloader />}>
                                <Task />
                            </Suspense>
                        </ProtectedRoute>
                    } 
                />
                <Route 
                    path="/settings" 
                    element={
                        <ProtectedRoute>
                            <Suspense fallback={<Preloader />}>
                                <Settings />
                            </Suspense>
                        </ProtectedRoute>
                    } 
                />
                <Route 
                    path="/profile" 
                    element={
                        <ProtectedRoute>
                            <Suspense fallback={<Preloader />}>
                                <Profile />
                            </Suspense>
                        </ProtectedRoute>
                    } 
                />
                <Route 
                    path="/projects" 
                    element={
                        <ProtectedRoute guestGateVariant="projects">
                            <Suspense fallback={<Preloader />}>
                                <Projects />
                            </Suspense>
                        </ProtectedRoute>
                    } 
                />
                <Route 
                    path="/project/:projectId" 
                    element={
                        <ProtectedRoute guestGateVariant="projects">
                            <Suspense fallback={<Preloader />}>
                                <Project />
                            </Suspense>
                        </ProtectedRoute>
                    } 
                />
                <Route 
                    path="/chat" 
                    element={
                        <Suspense fallback={<Preloader />}>
                            <Chat />
                        </Suspense>
                    } 
                />
                <Route 
                    path="/articles" 
                    element={
                        <Suspense fallback={<Preloader />}>
                            <Articles />
                        </Suspense>
                    } 
                />
                <Route 
                    path="/article/:articleId" 
                    element={
                        <Suspense fallback={<Preloader />}>
                            <Article />
                        </Suspense>
                    } 
                />

                {/* 404 - Not Found */}
                <Route 
                    path="*" 
                    element={
                        <Suspense fallback={<Preloader />}>
                            <NotFound />
                        </Suspense>
                    } 
                />
            </Routes>
        </Suspense>
    );
};

export default AppRoutes;

